import React, { Suspense, lazy, useEffect, useState } from "react";
import { CircularProgress, Typography } from "@mui/material";
import styles from "./member.module.css";
import useUserStore from "store/user";
import { useRolesContext } from "context/rolesContext";
import Spinner from "components/Spinner";
import { getWalkthroughUsers, getWalkthroughs } from "api/all.api";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router";

const WalkForm = lazy(() => import("components/WalkForm/WalkForm"));
const CustomWalkForm = lazy(() => import("components/WalkForm/CustomWalkForm"));
const WalkthroughAccordion = lazy(() =>
  import("components/Accordion/Accordion")
);

const Coaching = () => {
  const [isWalk, setIsWalk] = useState(true);
  const [isCustomWalk, setIsCustomWalk] = useState(true);
  const [editWalk, setEditWalk] = useState();
  const [currentWalk, setCurrentWalk] = useState({});
  const roles = useRolesContext();
  const { user } = useUserStore();
  const [userRole, setUserRole] = useState([]);
  const search = useLocation().search;
  let id = new URLSearchParams(search).get("id");

  const { data: users, status: userStatus } = useQuery({
    queryKey: ["walkusers"],
    queryFn: getWalkthroughUsers,
    staleTime: 1000 * 60 * 60,
  });

  const { data: walks, status: walkStatus } = useQuery({
    queryKey: ["walkthroughs"],
    queryFn: getWalkthroughs,
    staleTime: 1000 * 60 * 60,
  });

  useEffect(() => {
    if (id && walks) {
      const crmWalk = walks?.find((item) => item._id === id);
      if (crmWalk?.isCustom) {
        setCurrentWalk(crmWalk);
        setIsCustomWalk(false);
      } else {
        setEditWalk(crmWalk);
        setIsWalk(false);
      }
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    setUserRole(roles?.filter((role) => role?.title === user?.role));
  }, [roles, user]);

  const handleWalk = () => {
    setEditWalk(null);
    setIsWalk(!isWalk);
  };

  const handleCustomWalk = () => {
    setEditWalk(null);
    setIsCustomWalk(!isCustomWalk);
  };

  if (walkStatus === "loading" || userStatus === "loading")
    return (
      <div className="d-flex justify-content-center mt-5">
        <CircularProgress color="inherit" />
      </div>
    );

  return (
    <Suspense fallback={<Spinner />}>
      <div
        className={`${!isWalk || !isCustomWalk ? "hidden-walk" : "show-walk"} `}
      >
        <div>
          <div className="pb-4">
            <Typography variant="p" component="p" className="float-right">
              Total Coaching Forms: {walks.length}
            </Typography>
          </div>
          {user?.role === "superadmin" ||
          user?.role === "assistprincipal" ||
          user?.role === "admin" ||
          (userRole?.length && userRole[0]?.allowWalkthrough) ? (
            <div className="d-flex justify-content-end">
              <button
                className={`btn pl-4 pr-4 ${styles.add_btn}`}
                onClick={handleCustomWalk}
              >
                CREATE CUSTOM
              </button>
              <button
                className={`btn pl-4 pr-4 ${styles.add_btn}`}
                onClick={handleWalk}
              >
                ADD STANDARD
              </button>
            </div>
          ) : (
            <></>
          )}
          <div>
            <WalkthroughAccordion
              walks={walks}
              setEditWalk={setEditWalk}
              setCurrentWalk={setCurrentWalk}
              setIsWalk={setIsWalk}
              setIsCustomWalk={setIsCustomWalk}
              userId={user._id}
            />
          </div>
        </div>
      </div>
      <WalkForm
        setIsWalk={setIsWalk}
        editWalk={editWalk}
        isWalk={isWalk}
        walks={walks}
        isSuperAdmin={user?.role === "superadmin"}
        users={users}
        user={user}
      />
      <CustomWalkForm
        setIsCustomWalk={setIsCustomWalk}
        isCustomWalk={isCustomWalk}
        currentWalk={currentWalk}
        handleCustomWalk={handleCustomWalk}
        isSuperAdmin={user?.role === "superadmin"}
        users={users}
        user={user}
      />
    </Suspense>
  );
};

export default Coaching;
